<ul>
    <li class="header">
        <div class="regNo">{{'regNo' | translate}}</div>
        <div class="owner">{{'competency.user' | translate}}</div>
        <div class="approver">{{'competency.approvedBy' | translate}}</div>
        <div class="approved">{{'competency.approvedWhen' | translate}}</div>
        <div class="revoker">{{'competency.revokedBy' | translate}}</div>
        <div class="revoked">{{'competency.revokedWhen' | translate}}</div>

    </li>
    <li ng-repeat="issue in vm.previousIssues" class="competency-issue" ng-click="vm.show(issue)">
        <div class="regNo">{{issue.UniqueRegistrationNumber}}</div>
        <div class="owner">{{issue.Owner.DisplayName}}</div>
        <div class="approver">{{issue.Approver.DisplayName}}</div>
        <div class="approved">{{issue.ApprovedWhen | cDate}}</div>
        <div class="revoker">{{issue.RevokedBy.DisplayName}}</div>
        <div class="revoked">{{issue.RevokedWhen | cDate}}</div>
    </li>
</ul>